/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PortalConfigCreate } from '../models/PortalConfigCreate';
import type { PortalConfigDetails } from '../models/PortalConfigDetails';
import type { PortalConfigUpdate } from '../models/PortalConfigUpdate';
import { request as __request } from '../core/request';

export class PortalConfigsVService {

    /**
     * @param operatorId
     * @returns PortalConfigDetails OK
     * @throws ApiError
     */
    public static async portalConfigsVGetAll(
        operatorId: string,
    ): Promise<PortalConfigDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/Operators/${operatorId}/portal-configs`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns PortalConfigDetails Created
     * @throws ApiError
     */
    public static async portalConfigsVCreate(
        operatorId: string,
        requestBody?: PortalConfigCreate,
    ): Promise<PortalConfigDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Operators/${operatorId}/portal-configs`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param portalConfigId
     * @param requestBody
     * @returns PortalConfigDetails OK
     * @throws ApiError
     */
    public static async portalConfigsVUpdate(
        operatorId: string,
        portalConfigId: string,
        requestBody?: PortalConfigUpdate,
    ): Promise<PortalConfigDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/Operators/${operatorId}/portal-configs/${portalConfigId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param portalConfigId
     * @returns any No Content
     * @throws ApiError
     */
    public static async portalConfigsVDelete(
        operatorId: string,
        portalConfigId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/Operators/${operatorId}/portal-configs/${portalConfigId}`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns PortalConfigDetails OK
     * @throws ApiError
     */
    public static async portalConfigsVUpdateLastMessageTime(
        operatorId: string,
        requestBody?: string,
    ): Promise<PortalConfigDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/Operators/${operatorId}/portal-configs/last-message`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}